import { IFaqCategory } from '../../../faq.types'
import FaqGroupSelect from '../../FaqGroupSelect'
import faqApi from '../../../faq.api'
import faqEvents from '../../../events/faq.events'
import useHttpLoader from '../../../../../../shared/hooks/useHttpLoader'
import useStateWithChange from '../../../../../../shared/hooks/useStateWithChange'
import Modal from '../../../../../../shared/Modal'
import ModalHeader from '../../../../../../shared/Modal/ModalHeader'
import TextField from '../../../../../../shared/Forms/TextField'
import TextInput from '../../../../../../shared/Inputs/TextInput'
import NumberInput from '../../../../../../shared/Inputs/NumberInput'
import Button from '../../../../../../shared/Buttons/Button/Button'

interface IProps {
  onClose?: () => void
  initialParentId?: IFaqCategory['id']
}

const CreateGroupModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [state, _, handleChange] = useStateWithChange<Omit<IFaqCategory, 'id'>>({
    title: '',
    parentId: props.initialParentId ?? null,
    ordering: 0,
    active: false,
  })

  const handleSubmit = () => {
    wait(faqApi.createCategory(state), (resp) => {
      if (resp.status === 'success') {
        faqEvents.groupCreated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal onClose={props.onClose} size='md'>
      <ModalHeader onClose={props.onClose}>Создание группы</ModalHeader>
      <div className='modal-content'>
        <div className='flex-lines'>
          <TextField header='Наименование группы'>
            <TextInput value={state.title} name='title' onChange={handleChange} />
          </TextField>

          <div className='grid-form-2' style={{ paddingBottom: '200px' }}>
            <TextField header='Родительская группа'>
              <FaqGroupSelect value={state.parentId} name='parentId' onChange={handleChange} />
            </TextField>
            <TextField header='Положение в списке'>
              <NumberInput value={state.ordering} onChange={handleChange} name='ordering' />
            </TextField>
          </div>
        </div>
      </div>
      <div className='modal-footer'>
        <Button style={{ width: 'fit-content' }} theme='primary' onClick={handleSubmit} loading={loading}>
          Сохранить
        </Button>
      </div>
    </Modal>
  )
}

export default CreateGroupModal
